export var isDate = function isDate(d) {
  return d instanceof Date;
};
export var isEmpty = function isEmpty(o) {
  return Object.keys(o).length === 0;
};
export var isObject = function isObject(o) {
  return o != null && typeof o === 'object';
};
export var hasOwnProperty = function hasOwnProperty(o) {
  var _Object$prototype$has;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (_Object$prototype$has = Object.prototype.hasOwnProperty).call.apply(_Object$prototype$has, [o].concat(args));
};
export var isEmptyObject = function isEmptyObject(o) {
  return isObject(o) && isEmpty(o);
};